/**
 * Normalizes `aiAnalysis.model` and `aiAnalysis.modelAttempts` from the worker.
 * @param {Record<string, unknown> | null | undefined} ai
 */
export function primaryModelId(ai) {
  if (!ai || typeof ai !== "object") return "";
  const m = ai.model;
  return typeof m === "string" && m.trim() ? m.trim() : "";
}

/**
 * `provider/model` → short display name (last segment).
 * @param {string} full
 */
export function shortModelName(full) {
  if (!full || typeof full !== "string") return "";
  const t = full.trim();
  const i = t.lastIndexOf("/");
  return i >= 0 ? t.slice(i + 1).trim() || t : t;
}

/**
 * @param {unknown} raw
 * @returns {{ provider: string, model: string, ok: boolean, detail: string }[]}
 */
export function normalizeModelAttempts(ai) {
  const raw = ai && typeof ai === "object" ? ai.modelAttempts ?? ai.model_attempts : undefined;
  if (!Array.isArray(raw)) return [];
  return raw
    .map((row) => {
      if (!row || typeof row !== "object") return null;
      const o = /** @type {Record<string, unknown>} */ (row);
      return {
        provider: String(o.provider ?? "").trim() || "—",
        model: String(o.model ?? "").trim() || "—",
        ok: Boolean(o.ok),
        detail: typeof o.detail === "string" ? o.detail.trim() : "",
      };
    })
    .filter(Boolean);
}

export function hasModelDetailsToShow(ai) {
  return Boolean(primaryModelId(ai) || normalizeModelAttempts(ai).length);
}
